// extracted by mini-css-extract-plugin
export default {"formTitle":"OemDrawer_formTitle__2DB00","confirmModal":"OemDrawer_confirmModal__yyBJg"};